import React, { Component } from 'react'
import { Switch, Route, Redirect } from 'react-router-dom'
import { Container } from 'reactstrap'
import Header from '../../components/Header/'

import Sidebar from '../../components/Sidebar/'
import ResponsiveSidebar from '../../components/Sidebar/ResponsiveSidebar'

import Breadcrumb from '../../components/Breadcrumb/'
import Footer from '../../components/Footer/'
import { connect } from 'react-redux'
import { ToastContainer } from 'react-toastify'

import * as session from '../../services/session'
import * as api from '../../services/session/api'
import * as userSession from '../../services/session'


import Pages from '../../views/Cms/Pages/Pages'
import Page from '../../views/Cms/Pages/Page'
import PageView from '../../views/Cms/Pages/View'
import Posts from '../../views/Cms/Posts/Posts'
import Post from '../../views/Cms/Posts/Post'
import Medias from '../../views/Cms/Medias/Medias'



import * as sessionService from '../../services/session'

class Full extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loaded: false,
      isAdmin: false,
      isTCP: false,
      isADV: false,
      redirectDashboard: false,
      timeout: null
    }

    this.getCurrentUser = this.getCurrentUser.bind(this)
    this.setListener = this.setListener.bind(this)
    this.autoConnect = this.autoConnect.bind(this)
    this.setTimeoutTime = this.setTimeoutTime.bind(this)
    this.logout = this.logout.bind(this)
  }

  componentWillMount() {
    this.autoConnect()
    this.setListener()
    // this.setTimeoutTime(100000);
  }

  setTimeoutTime(time) {
    let self = this

    if (time - self.props.activityTime > 1800000) {
      self.props.setActivityTime(time)
      //Fait péter les selects des tableaux
      //self.logout();
    }
    self.props.setActivityTime(time)
  }

  setListener() {
    var that = this
    var t
    //window.onload = resetTimer;
    window.onmousemove = resetTimer // catches mouse movements
    window.onmousedown = resetTimer // catches mouse movements
    window.onclick = resetTimer // catches mouse clicks
    window.onscroll = resetTimer // catches scrolling
    window.onkeypress = resetTimer //catches keyboard actions

    function resetTimer() {
      clearTimeout(t)
      t = setTimeout(that.logout, 1800000) // time is in milliseconds (1000 is 1 second)
    }
  }

  autoConnect() {
    session
      .authenticated()
      .then(() => {
        this.getCurrentUser()
      })
      .catch(exception => {
        this.props.history.push('/login')
      })
  }

  /**
   * Récupération du user courant
   */
  getCurrentUser() {
    api
      .getMe()
      .then(data => {
        this.props.setUser(data)

        session.setUser(data)

        if(!userSession.testRole('ROLE_ADMIN')){
          sessionService.revoke().then(res => {
            this.props.history.push('/login')
          })
        }

        const isAdmin = userSession.testRole('ROLE_ADMIN')


        this.setState(
          {
            loaded: true,
            isAdmin
          }
        )
      })
      .catch(exception => {
        this.props.history.push('/login')
      })
  }

  logout() {
    console.log('logout')
    sessionService.revoke().then(res => {
      this.props.history.push('/login')
    })
  }

  render() {
    const { isAdmin, isTCP, redirectDashboard, redirectSeller, isADV } = this.state
    return (
      <div className="app">
        <Header isAdmin={isAdmin} isTCP={isTCP} isADV={isADV} />
        <ToastContainer position="top-center" hideProgressBar={true} autoClose={3000} />
        <div className="app-body">
          <div className={"responsive-sidebar"}>
            <ResponsiveSidebar {...this.props} />
          </div>
          <div className={"classic-sidebar"}>
            <Sidebar {...this.props} />
          </div>


          <main className="main">
            <Breadcrumb />
            <Container fluid>
              <Switch>
                <Route path="/page/:id" name="Gestion des pages" component={PageView} />
                {isAdmin && <Route path="/pages/edit/:id" name="Gestion des pages" component={Page} />}
                {isAdmin && <Route path="/pages/edit" name="Gestion des pages" component={Page} />}
                {isAdmin && <Route path="/pages" name="Gestion des pages" component={Pages} />}
                {isAdmin && <Route path="/posts/edit/:id" name="Gestion des posts" component={Post} />}
                {isAdmin && <Route path="/posts/edit" name="Gestion des posts" component={Post} />}
                {isAdmin && <Route path="/posts" name="Gestion des Articles" component={Posts} />}
                {isAdmin && <Route path="/medias" name="Gestion des Medias" component={Medias} />}
              </Switch>
            </Container>
          </main>
        </div>
        <Footer />
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    user: state.user,
    activityTime: state.user.lastTimeActitity
  }
}

const mapDispatchToProps = dispatch => ({
  setUser: user => {
    dispatch({ type: 'SET_USER', user })
  },

  setActivityTime: time => {
    //Fait planter le select des tableaux
    //dispatch({type: 'SET_ACTIVITY_TIME', time});
  }
})

module.exports = connect(mapStateToProps, mapDispatchToProps)(Full)



// WEBPACK FOOTER //
// ./src/containers/Full/Full.js